<script setup>
import { sanitizeHtml } from '@core/utils/sanitizeHtml'

const props = defineProps({
  confirmationMsg: {
    type: String,
    required: true
  },
  confirmBtnText: {
    type: String,
  },
  cancelBtnText: {
    type: String,
  },
  isDialogVisible: {
    type: Boolean,
    required: true
  }
})

const emit = defineEmits([
  'update:isDialogVisible',
  'confirm',
  'cancel'
])

const updateModelValue = val => {
  emit('update:isDialogVisible', val)
}
const onConfirmation = () => {
  emit('confirm', true)
  updateModelValue(false)
}
const onCancel = () => {
  emit('cancel', true)
  emit('update:isDialogVisible', false)
}
const onClose = () => {
  emit('close', true)
  emit('update:isDialogVisible', false)
}
</script>

<template>
  <!-- 👉 Confirm Dialog -->
  <VDialog
    max-width="500"
    :model-value="props.isDialogVisible"
    @update:model-value="updateModelValue"
  >
    <VCard class="text-center px-10 py-6">
      <VCardText>
        <VBtn
          icon
          variant="outlined"
          color="primary"
          class="mb-4"
          style="pointer-events: none;"
        >
          <span class="text-5xl">!</span>
        </VBtn>

        <div
          class="text-lg font-weight-medium"
          v-html="sanitizeHtml(props.confirmationMsg)"
        />
      </VCardText>

      <VCardActions class="align-center justify-center gap-2">
        <VBtn
          variant="elevated"
          @click="onConfirmation"
        >
          {{ props.confirmBtnText || 'Confirm' }}
        </VBtn>

        <VBtn
          color="secondary"
          variant="tonal"
          @click="onCancel"
        >
          {{ props.cancelBtnText || 'Cancel' }}
        </VBtn>
      </VCardActions>
    </VCard>
    <VBtn
      icon="$close"
      size="large"
      variant="text"
      color="secondary"
      class="dialog-close-btn"
      @click="onClose"
    >
      <VIcon>mdi-close</VIcon>
    </VBtn>
  </VDialog>
</template>

<style scoped>
.dialog-close-btn {
  position: fixed;
  right: 6px;
  top: 6px;
}
</style>
